// extracted by mini-css-extract-plugin
export default {"main":"Wca-z"};